export const PUBLIC_PROFILE_QUERY_STRING = {
  PUBLIC_PROFILE_ALL: 'publicInfo',
};
